import { applyMiddleware, compose, createStore } from "redux";
import thunk from "redux-thunk";
import rootReducer from "../reducers/index";
import { persistStore } from "redux-persist";

let middleware = [];
middleware = [...middleware, thunk];

// Configure Redux DevTools Extension
// const composeEnhancers =
  // (typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

const store = createStore(
  rootReducer, 
  compose(applyMiddleware(...middleware))
  // composeEnhancers(applyMiddleware(...middleware))
);

const getStore = () => {
  return store;
};

export { store, getStore };
export const persistor = persistStore(store);
